import React, { useEffect, useState } from "react";
import withWidth from "@material-ui/core/withWidth";
import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import FaceIcon from "@material-ui/icons/Face";
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import HomeIcon from "@material-ui/icons/Home";
import InfoIcon from "@material-ui/icons/Info";
import { logoutUser } from "../../service/logic";
import { history } from "../../index";
import MenuIcon from "@material-ui/icons/Menu";
import {
  clearGameState,
  setPresentationFlag,
  showModal,
} from "../../redux/dispatchers";
import { CustomIconButton, useWindowDimensions } from "./index";
import { InfoComponent } from "../../components";
import { useSelector } from "react-redux";
import { GAME_STAGE } from "../../utils/constant";

const useStyles = makeStyles((theme) => ({
  header: {
    position: "fixed",
    right: 10,
    top: 12,
    display: "flex",
    flexDirection: "column",
    flex: 0,
    zIndex: 10,
  },
  icons: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "flex-start",
  },
  icon: {
    borderRadius: "50%",
    width: 50,
    height: 50,
    marginRight: 10,
    marginBottom: theme.spacing(1),
    marginTop: 10,
    "&:hover": {
      boxShadow:
        "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    },
  },
  avatarIcon: {
    width: 40,
    height: 40,
    color: "white",
  },
  menuButton: {
    height: 50,
    width: 50,
    background: "#C4C4C4",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 10,
    cursor: "pointer",
  },
  menuButtonPressed: {
    height: 50,
    width: 50,
    background: "#A8DADC",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 10,
    cursor: "pointer",
  },
  collapseBody: {
    alignSelf: "flex-end",
    display: "flex",
    flexDirection: "column",
  },
  menuContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    marginBottom: 10,
  },
  collapseContainer: {
    flex: 1,
    background: "#C4C4C4",
    borderRadius: 10,
    padding: "0px 10px",
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
  },
  text: {
    cursor: "pointer",
  },
  background: {
    position: "fixed",
    zIndex: 11,
    top: 0,
    left: 0,
    width: "100%",
    backgroundColor: "black",
    opacity: "0.5",
    height: "100%",
  },
}));

const HeaderComponent = ({ width }) => {
  const theme = useTheme();
  const isWidthSm = useMediaQuery(theme.breakpoints.down("xs"));
  const [collapse, setCollapse] = useState(false);
  const [info, setInfo] = useState(false);
  const { page } = useSelector((state) => state.gameStates);
  const { height } = useWindowDimensions();

  useEffect(() => {
    if (width !== "xs") {
      setCollapse(false);
    }
  }, [width]);

  const toggleCollapse = () => {
    setCollapse(!collapse);
  };

  const navigateGlossary = () => {
    history.push("/resources");
  };

  const navigatePresentation = () => {
    setPresentationFlag(true);
    history.push("/presentation");
  };

  const navigate = () => {
    switch (page) {
      case "/history":
        return GAME_STAGE.HISTORY_TAKING;
      case "/historysummary":
        return GAME_STAGE.HISTORY_SUMMARY;
      case "/diagnosis":
        return GAME_STAGE.DIAGNOSIS_1;
      case "/diagnosis2":
        return GAME_STAGE.DIAGNOSIS_2;
      case "/exam":
        return GAME_STAGE.EXAMINATION;
      case "/examevaluation":
        return GAME_STAGE.EXAMINATION_EVALUATION;
      case "/investigation":
        return GAME_STAGE.INVESTIGATION;
      case "/investigationevaluation":
        return GAME_STAGE.INVESTIGATION_EVALUATION;
      case "/finaldiagnosis":
        return GAME_STAGE.FINAL_DIAGNOSIS;
      case "/diagnosisevaluation":
        return GAME_STAGE.FINAL_DIAGNOSIS_EVALUATION;
      case "/management":
        return GAME_STAGE.MANAGEMENT;
      case "/managementevaluation":
        return GAME_STAGE.MANAGEMENT_EVALUATION;
      case "/finalmarks":
        return GAME_STAGE.FINAL_MARKS;
      case "/casesummary":
        return GAME_STAGE.CASE_SUMMARY;
      default:
        return 1;
    }
  };

  const gameStage = navigate();

  useEffect(() => {
    setInfo(false);
  }, [gameStage]);

  const classes = useStyles();
  return (
    <div>
      <div
        className={classes.background}
        style={{
          display: collapse ? "block" : "none",
        }}
        onClick={() => {
          setCollapse(false);
        }}
      />
      <InfoComponent stage={gameStage - 1} info={info} setInfo={setInfo} />
      <div
        className={classes.header}
        style={{ zIndex: collapse ? "11" : "10" }}
        id="desktopHeaderRoot"
      >
        {isWidthSm || height < 460 ? (
          <>
            <div className={classes.collapseBody}>
              <div className={classes.menuContainer}>
                <div
                  className={
                    collapse ? classes.menuButtonPressed : classes.menuButton
                  }
                  onClick={toggleCollapse}
                >
                  <MenuIcon />
                </div>
              </div>
              <div className={classes.collapseContainer}>
                <Collapse in={collapse}>
                  <List>
                    <ListItem
                      id={"casepresentation"}
                      onClick={navigatePresentation}
                    >
                      <ListItemAvatar>
                        <FaceIcon
                          className={classes.avatarIcon}
                          style={{ color: "white" }}
                          alt={"Case Presentation"}
                        />
                      </ListItemAvatar>
                      <ListItemText
                        className={classes.text}
                        primary="Case Presentation"
                      />
                    </ListItem>
                    <Divider />
                    <ListItem onClick={navigateGlossary} id="resources">
                      <ListItemAvatar>
                        <MenuBookIcon className={classes.avatarIcon} />
                      </ListItemAvatar>
                      <ListItemText
                        className={classes.text}
                        primary="Resources"
                      />
                    </ListItem>
                    <Divider />
                    <div
                      style={{
                        display: gameStage < 14 ? "block" : "none",
                      }}
                    >
                      <ListItem
                        id={"info"}
                        onClick={() => {
                          setCollapse(false);
                          setTimeout(() => {
                            setInfo(true);
                          }, 200); //time spare to collapse the header component
                        }}
                      >
                        <ListItemAvatar>
                          <InfoIcon className={classes.avatarIcon} />
                        </ListItemAvatar>
                        <ListItemText className={classes.text} primary="Info" />
                      </ListItem>
                      <Divider />
                    </div>
                    <ListItem
                      id={"quit"}
                      onClick={() => {
                        showModal(
                          "Quit Game",
                          "Are you sure you want to quit the game now? You will lose your current game states!",
                          "Confirm",
                          "Cancel",
                          () => {
                            clearGameState();
                            history.push("/cases");
                          }
                        );
                      }}
                    >
                      <ListItemAvatar>
                        <HomeIcon className={classes.avatarIcon} />
                      </ListItemAvatar>
                      <ListItemText
                        className={classes.text}
                        primary="Quit Game"
                      />
                    </ListItem>
                    <Divider />
                    <ListItem
                      id={"logout"}
                      onClick={() => {
                        showModal(
                          "Log Out",
                          "Are you sure you want to log out now? You will lose your current game states!",
                          "Confirm",
                          "Cancel",
                          logoutUser
                        );
                      }}
                    >
                      <ListItemAvatar>
                        <ExitToAppIcon className={classes.avatarIcon} />
                      </ListItemAvatar>
                      <ListItemText
                        className={classes.text}
                        primary="Log Out"
                      />
                    </ListItem>
                  </List>
                </Collapse>
              </div>
            </div>
          </>
        ) : (
          <div className={classes.icons}>
            <div>
              <CustomIconButton
                id="casepresentation"
                Icon={FaceIcon}
                onClick={navigatePresentation}
                label="Case Presentation"
                blue
              />
              <div style={{ marginBottom: 15 }} />
              <CustomIconButton
                id="resources"
                Icon={MenuBookIcon}
                onClick={navigateGlossary}
                label="Resources"
                blue
              />
              <div style={{ marginBottom: 15 }} />
              <div
                style={{
                  display: gameStage < 14 ? "block" : "none",
                }}
              >
                <CustomIconButton
                  id="info"
                  Icon={InfoIcon}
                  onClick={() => {
                    setInfo(true);
                  }}
                  label="Info"
                  blue
                />
                <div style={{ marginBottom: 15 }} />
              </div>
              <CustomIconButton
                id="quit"
                Icon={HomeIcon}
                onClick={() => {
                  showModal(
                    "Quit Game",
                    "Are you sure you want to quit the game now? You will lose your current game states!",
                    "Confirm",
                    "Cancel",
                    () => {
                      clearGameState();
                      history.push("/cases");
                    }
                  );
                }}
                label="Quit Game"
                blue
              />
              <div style={{ marginBottom: 15 }} />
              <CustomIconButton
                id="logout"
                Icon={ExitToAppIcon}
                onClick={() => {
                  showModal(
                    "Log Out",
                    "Are you sure you want to log out now? You will lose your current game states!",
                    "Confirm",
                    "Cancel",
                    logoutUser
                  );
                }}
                label="Log Out"
                blue
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default withWidth()(HeaderComponent);
